export default "__VITE_ASSET__DhNCquOv__"